const getFileBlob = async (file: File) => {
    const arrayBuffer = await file.arrayBuffer();
    return new Blob(
        [new Uint8Array(arrayBuffer)],
        { type: file.type },
    );
};

export default getFileBlob;
